const LogoMain = () => {
  return (
    <div className="flex items-center gap-2">
      {/* Logo monocromático (árvore) em fundo transparente.
          `dark:invert` deixa o traço branco no tema escuro. */}
      <img
        src="/AvoriaLogo.svg"
        alt="Avoria"
        className="w-12 transition-opacity duration-300 dark:invert"
      />
    </div>
  );
};

export default LogoMain;
